import logoWhite from "common/assets/images/traitify/powered-by-traitify.png";
import useAppContext from "common/hooks/use-app-context";
import {isWhite} from "common/lib/ext/color";

export default function Logo() {
  const {current: {organization: {options}}} = useAppContext();
  const isDefaultLogo = options.navbar_logo.url.includes("default-logo");
  const isWhiteLogo = isDefaultLogo && options.navbar_color && !isWhite(options.navbar_color);
  const logo = isWhiteLogo ? logoWhite : options.navbar_logo.url;

  return <img alt="Traitify" src={logo} />;
}
